import { postJSONPS } from './lib/utils/fetch';
import { composePS } from '@cd/pipe';

const postGetServerVar = varName =>
	composePS(postJSONPS)('GET', `/config/var/${varName}`);

export default postGetServerVar;
